<ng-template #newFoodTemplate>
	<mod-food-form (create)="handleCreateFood($event)" [isInDialog]="true"></mod-food-form>
</ng-template>

<ng-template #noMealsMessage>
	<lib-message [type]="'noDataOnBody'">There are no meals in this diet.</lib-message>
</ng-template>

@if (enablePreview()) {
<div class="push-bottom" libFlexRow [libFlexRowAlign]="'center'">
	<div libFlexColumn libFlexFill></div>
	<div libFlexColumn>
		<lib-checkbox-form-input
			[label]="'Show preview'"
			[checked]="!isEdit()"
			(valueChange)="isEdit.set(!isEdit())"
		></lib-checkbox-form-input>
	</div>
</div>
} @if (diet(); as diet) {
<div>
	<!-- View -->
	@if (isEdit() === false) { @if (diet.notes) {
	<lib-message class="push-bottom" [type]="'info'" [title]="'Notes'">
		<div [innerHTML]="diet.notes | textToHtml"></div>
	</lib-message>
	} @if (extendedDietFoodContainers(); as dietfoodContainers) { @if (dietfoodContainers?.length) {
	<div class="push-top">
		@for ( foodContainer of dietfoodContainers; track foodContainer.originalContainer.id; let containerIndex =
		$index; let firstContainer = $first; let lastContainer = $last) {
		<div [class.push-top]="!firstContainer">
			<lib-card class="push-top" [title]="foodContainer.shownTitle()" [subtitle]="foodContainer.shownSubtitle">
				@for ( food of foodContainer.foods; track food.originalDietFood.id; let firstFood = $first; let lastFood
				= $last) {
				<div>
					<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
						@if (food.foodAvatar) {
						<div libFlexColumn>
							<lib-image
								[alt]="'Food avatar'"
								[maxHeight]="40"
								[maxWidth]="40"
								[image]="food.foodAvatar"
								[imageSize]="'50px'"
							></lib-image>
						</div>
						}
						<div libFlexColumn [libFlexSize]="'fill'">
							<div>
								{{ food.name }}
							</div>
							<div libText5>
								{{ food.amountText }}
							</div>
							@if (isMobileView()) {
							<div libFlexColumn libText5>{{ food.nutrition.kcal }} kcal</div>
							}
						</div>
						@if (!isMobileView()) {
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
							<lib-nutrition-boxes
								[design]="'tags'"
								[nutritionRowAlign]="'space-around'"
								[kcal]="food.nutrition.kcal"
								[carbs]="food.nutrition.carbs"
								[proteins]="food.nutrition.proteins"
								[fats]="food.nutrition.fats"
							></lib-nutrition-boxes>
						</div>
						}
					</div>
					@if (food.notes) {
					<div class="push-top-sm" libText3>
						{{ food.notes }}
					</div>
					}
					<div>
						<lib-divider class="push-top push-bottom"></lib-divider>
					</div>
				</div>
				}

				<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
						<div libText5>Total</div>
					</div>
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
						<lib-nutrition-boxes
							[design]="'tags'"
							[nutritionRowAlign]="'space-around'"
							[kcal]="foodContainer.mealNutrition.kcal"
							[carbs]="foodContainer.mealNutrition.carbs"
							[proteins]="foodContainer.mealNutrition.proteins"
							[fats]="foodContainer.mealNutrition.fats"
						></lib-nutrition-boxes>
					</div>
				</div>
			</lib-card>
		</div>
		}
	</div>
	} @else {
	<div class="push-top">
		<ng-template [ngTemplateOutlet]="noMealsMessage"></ng-template>
	</div>
	} } }

	<!-- Edit -->
	@if (isEdit() === true) {

	<div>
		<lib-message [type]="'tip'" [dismissId]="'edit-diet-tip'" [className]="'push-bottom'">
			@if (sharedData()?.data?.clientData) {
			<div>
				You are editing client diet plan. Any changes made here will NOT affect original template from which
				this diet was assigned.
			</div>
			} @else {
			<div>
				You are editing a template. Any changes you make here will NOT affect diets already assigned to clients
				using this template.
			</div>
			<div class="push-top-sm">Once you assign a template to a client, it becomes independent.</div>
			}
		</lib-message>
	</div>

	<lib-message class="push-bottom" [type]="'info'" [title]="'Diet notes'" [button]="editNotesButton()">
		<div [innerHTML]="diet.notes ?? 'n/a' | textToHtml"></div
	></lib-message>

	<ng-container>
		@if (editQuickActionButtons(); as editQuickActionButtons) { @if (editQuickActionButtons.length) {
		<lib-card class="push-bottom-md" [addContentDivider]="true" [title]="'Designer Actions'" [enableCard]="false">
			<lib-button-list
				[mode]="'extendedList'"
				[extendListThreshold]="1"
				[useFullSizeButtons]="false"
				[buttons]="editQuickActionButtons"
			></lib-button-list>
		</lib-card>
		} }
	</ng-container>

	@if (extendedDietFoodContainers(); as dietfoodContainers) { @if (dietfoodContainers?.length) {

	<div class="push-top">
		@for ( foodContainer of dietfoodContainers; track foodContainer.originalContainer.id; let containerIndex =
		$index; let firstContainer = $first; let lastContainer = $last) {
		<div class="w-anchor" [id]="foodContainer.domId"></div>
		<div [class.push-top]="!firstContainer">
			<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="'center'">
				<div libFlexColumn>
					<h4 libLightText1>{{ containerIndex + 1 }}</h4>
				</div>
				<div libFlexColumn libFlexFill></div>
				<div libFlexColumn>
					<lib-button-list
						[mode]="isMobileView() ? 'list' : 'list'"
						[buttons]="foodContainer.outsideContainerButtons"
					></lib-button-list>
				</div>
			</div>

			<lib-card class="push-top-sm">
				<div class="push-bottom" [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
					@if (!isMobileView()) {
					<div libFlexColumn [libFlexSize]="undefined">
						<lib-button-list
							[mode]="'list'"
							[extendListThreshold]="1"
							[buttons]="foodContainer.insideContainerButtons"
						></lib-button-list>
					</div>
					}
					<div libFlexColumn [libFlexSize]="isMobileView() ? 'fill' : '300px'">
						<ui-text-form-field
							[placeholder]="'Meal type...'"
							[isRequired]="true"
							[useDebounce]="true"
							[maxLength]="titleMaxLength"
							[valueAsSignal]="foodContainer.shownTitle"
							(valueChange)="handleSetTitle(foodContainer, $event)"
						></ui-text-form-field>
					</div>
					<div libFlexColumn>
						<lib-button-list
							[mode]="'single'"
							[moreIcon]="'settings'"
							[buttons]="foodContainer.mealTypeButtons"
							[singleButtonTooltip]="'Meal type'"
						></lib-button-list>
					</div>
					@if (isMobileView()) {
					<div libFlexColumn [libFlexSize]="'full'">
						<lib-button-list
							[mode]="'list'"
							[extendListThreshold]="1"
							[buttons]="foodContainer.insideContainerButtons"
						></lib-button-list>
					</div>
					}
				</div>

				@for ( food of foodContainer.foods; track food.originalDietFood.id; let firstFood = $first; let lastFood
				= $last) {
				<div>
					<div
						class="w-food-item"
						[libHover]="'w-food-item-hover'"
						[class.first]="firstFood"
						(click)="handleClickFoodItem(foodContainer, food)"
						(keyup.enter)="handleClickFoodItem(foodContainer, food)"
					>
						<div libFlexRow [libFlexRowGap]="'16px'" [attr.aria-hidden]="true">
							@if (food.foodAvatar) {
							<div libFlexColumn>
								<lib-image
									[alt]="'Food avatar'"
									[maxHeight]="40"
									[maxWidth]="40"
									[image]="food.foodAvatar"
									[imageSize]="'50px'"
								></lib-image>
							</div>
							} @if (food.pieGraph && !isMobileView()) {
							<div libFlexColumn>
								<lib-pie-chart
									[view]="[30, 30]"
									[showLabels]="false"
									[singleSeries]="food.pieGraph.singleSeries"
									[colorScheme]="food.pieGraph.colorScheme"
								></lib-pie-chart>
							</div>
							}
							<div libFlexColumn [libFlexSize]="'fill'">
								<div>
									<div libText1>
										{{ food.name }}
									</div>

									@if (isMobileView()) {
									<div libFlexRow class="push-top-xs">
										@if (food.pieGraph) {
										<div libFlexColumn>
											<lib-pie-chart
												[view]="[25, 25]"
												[showLabels]="false"
												[singleSeries]="food.pieGraph.singleSeries"
												[colorScheme]="food.pieGraph.colorScheme"
											></lib-pie-chart>
										</div>
										}
										<div libFlexColumn libFlexFill>
											<div libText5>
												{{ food.amountText }}
											</div>
											<div libText5>{{ food.nutrition.kcal }} kcal</div>
										</div>
										<div libFlexColumn>
											<lib-button-list [mode]="'list'" [buttons]="food.buttons"></lib-button-list>
										</div>
									</div>
									} @else {
									<div libText5>
										{{ food.amountText }}
									</div>
									}
								</div>
							</div>
							@if (!isMobileView()) {
							<div libFlexColumn [libFlexSize]="undefined">
								<lib-nutrition-boxes
									[design]="'tags'"
									[nutritionRowAlign]="'space-around'"
									[kcal]="food.nutrition.kcal"
									[carbs]="food.nutrition.carbs"
									[proteins]="food.nutrition.proteins"
									[fats]="food.nutrition.fats"
								></lib-nutrition-boxes>
							</div>
							<div libFlexColumn [libFlexSize]="'90px'">
								<lib-button-list [mode]="'list'" [buttons]="food.buttons"></lib-button-list>
							</div>
							}
						</div>

						@if (food.notes) {
						<div class="push-top-sm" libText3>
							{{ food.notes }}
						</div>
						}
					</div>
					<div>
						<lib-divider></lib-divider>
					</div>
				</div>
				}

				<div class="w-total-item">
					<div [libFlexRow]="isMobileView()" [libFlexRowGap]="'16px'">
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : 'fill'">
							<div libText5>Total</div>
						</div>
						<div libFlexColumn [libFlexSize]="isMobileView() ? 'full' : undefined">
							<lib-nutrition-boxes
								[design]="'tags'"
								[nutritionRowAlign]="'space-around'"
								[kcal]="foodContainer.mealNutrition.kcal"
								[carbs]="foodContainer.mealNutrition.carbs"
								[proteins]="foodContainer.mealNutrition.proteins"
								[fats]="foodContainer.mealNutrition.fats"
							></lib-nutrition-boxes>
						</div>
						@if (!isMobileView()) {
						<div libFlexColumn [libFlexSize]="'90px'"></div>
						}
					</div>
				</div>
			</lib-card>
		</div>
		}
	</div>

	@if (addMealToBottomButtons(); as addMealToBottomButtons) {
	<ng-container>
		@if (addMealToBottomButtons.length) {
		<div class="push-top">
			<lib-button-list
				[mode]="isMobileView() ? 'list' : 'list'"
				[useFullSizeButtons]="isMobileView()"
				[buttons]="addMealToBottomButtons"
			></lib-button-list>
		</div>
		} </ng-container
	>} } @else {
	<div class="push-top">
		<ng-template [ngTemplateOutlet]="noMealsMessage"></ng-template>
	</div>
	} } }
</div>
}
